import { useQuery } from '@tanstack/react-query';
import { getTypeOrganization } from '@/services/generic';

export const useTypeOrganization = () => {
  const queryKey = ['type-organization'];
  return useQuery({
    queryKey,
    queryFn: getTypeOrganization,
    select: (data) => ({
      originalData: data,
      select: data.map((item) => ({
        label: item.name,
        value: item.id,
      })),
    }),
  });
};
